import { Directive } from '@angular/core';

@Directive({
  selector: 'panel-body'
})
export class PanelBodyDirective { }
